/**
 * Single entry point for fetching the callsource session ID.
 *
 * window.aiIdExchange() hits the same ddc_id_exchange endpoint and resolves
 * the same { callsourceSessionId } shape whether or not a tcdcmpid is passed -
 * the tcdcmpid is optional enrichment (links the session to an ad campaign
 * click), not a requirement. So this works on every callsource-enabled page,
 * not just ones arriving from a TCD ad click.
 *
 * Caches the in-flight promise so multiple callers on the same page load
 * (aiIdExchange.js's own ad-attribution flow, index.js's AutoID number-swap
 * flow) share one exchange call instead of firing it twice.
 */
let sessionIdPromise = null;

export const getCallsourceSessionId = (tcdcmpid) => {
	if (!window.aiIdExchange) {
		return Promise.resolve(null);
	}

	if (!sessionIdPromise) {
		sessionIdPromise = window
			.aiIdExchange(tcdcmpid)
			.then(({ callsourceSessionId } = {}) => callsourceSessionId || null)
			.catch(() => null);
	}

	return sessionIdPromise;
};

// Exposed for test isolation only - the module-level cache above needs
// resetting between test cases since jest does not reset modules by default.
export const resetCallsourceSessionCache = () => {
	sessionIdPromise = null;
};
